import React, { useRef, useEffect, useState, useContext } from "react";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { InputText } from "primereact/inputtext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getOrdenesTrabajo } from "../../../../API/Mantenimiento/Requisas/RequisasMantenimientoRequests";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

export const OrdenesOverlayPanel = ({ close, values, onChange, enable}) => {

  const { userAuth } = useContext(AuthContext);
  const op = useRef(null);
  const buttom = useRef(null);

  const [loading, setLoading] = useState(false);
  const [ordenes, setOrdenes] = useState([]);

  const obtenerOrdenesTrabajo = async () => {
    setLoading(true);
    const tempo = await getOrdenesTrabajo();
    setOrdenes(tempo);
    setLoading(false);
  };

  const colums = [
    {
      header: "IdOrden",
      field: "IdOrdenTrabajo",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Orden Trabajo",
      field: "OrdenTrabajo",
      className: "small",
    },
    {
      header: "Fecha Solicitud",
      field: "FechaSolicitud",
      className: "small",
      Format: "DateTime",
    },
    {
      header: "Maquina",
      field: "Maquina",
      className: "small",
    },
    {
      header: "Descripcion",
      field: "Descripcion",
      className: "large",
    },
    {
      header: "En Paro",
      field: "EnParo",
      className: "Xsmall",
    },
    {
      header: "Area",
      field: "Area",
      className: "medium",
    },
    {
      header: "Solicita",
      field: "Solicita",
      className: "large",
    },
    {
      header: "Motivo",
      field: "Motivo",
      className: "medium",
    },
    {
      header: "Prioridad",
      field: "Priority",
      className: "Xsmall",
    },
    {
      header: "Operador",
      field: "Operador",
      className: "large",
    },
    {
      header: "Paro de Maquina",
      field: "ParoMaquina",
      className: "medium",
    },
    {
      header: "Tipo Trabajo",
      field: "TipoTrabajo",
      className: "small",
    },
  ];

  const table = {
    Columns: colums,
    Data: ordenes,
    loading: loading,
    onCellClicked: (e) => onChange(e, op),
  };

  useEffect(() => {
    obtenerOrdenesTrabajo();
  }, []);
  
  return (
    <div style={{ maxWidth: "25vw" }}>
      <div className="p-inputgroup p-float-label "  >
        <InputText style={{width: 171}}
          value={values.OrdenTrabajo?.OrdenTrabajo}
          disabled placeholder="Orden de Trabajo"
          onClick={(e) => op.current.toggle(e)}
        />
        <label>Orden Trabajo</label>
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.67rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
          disabled={!enable}
        />
      </div>
      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverPanelOrdenes"
        onHide={close}
        enable={enable}
      >
        <div style={{ width: 900, height: 400 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};
